import { createAction, props } from '@ngrx/store';
import { User } from '@shared/models/user';

export const loadGroupUsers = createAction('[Users] Load Group Users');

export const loadGroupUsersSuccess = createAction('[Users] Load Group Users Success', props<{ data: User[] }>());

export const loadGroupUsersFailure = createAction('[Users] Load Group Users Failure', props<{ error: any }>());
